// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dustox: PokeData = {
  "id": 269,
  "name": "dustox",
  "height": 12,
  "weight": 316,
  "base_experience": 173,
  "types": [
    PokeType.BUG,
    PokeType.POISON
  ],
  "api_moves": [
    "gust",
    "whirlwind",
    "tackle",
    "poison-sting",
    "psybeam",
    "poison-powder",
    "string-shot",
    "toxic",
    "confusion",
    "harden",
    "light-screen",
    "leech-life",
    "protect",
    "moonlight",
    "silver-wind",
    "extrasensory",
    "iron-defense",
    "bug-buzz",
    "bug-bite",
    "venoshock",
    "quiver-dance"
  ],
  "moves": [
    "gust",
    "tackle",
    "poison-powder",
    "string-shot",
    "protect",
    "moonlight",
    "bug-buzz",
    "bug-bite",
    "acid-rain",
    "poison-fang",
    "toxic-spikes",
    "toxic-overload",
    "lunge"
  ],
  "evolution_chain": {
    "id": 135,
    "item": null,
    "species": [
      {
        "name": "wurmple",
        "order": 290,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "silcoon",
        "order": 291,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": 265,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 7,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "beautifly",
        "order": 292,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 266,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 10,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "cascoon",
        "order": 293,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": 265,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 7,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "dustox",
        "order": 294,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": 268,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 10,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 140,
    "speed": 130,
    "ability_power": 100
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
